import ContactsIcon from '@mui/icons-material/Contacts';
import { Alert, Card, CardContent, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useEffect } from 'react';
import { OnlyFansSubscriptionsUserType } from '../../../../hooks/useSubscriber';

type Props = {
    targetUsers: OnlyFansSubscriptionsUserType;
    setTargetUsers: (targetUsers: OnlyFansSubscriptionsUserType) => void;
    unitCost: number;
    session?: any;
};

const MessageUsersFormTargetUsers = (props: Props) => {
    const { targetUsers, setTargetUsers, unitCost, session } = props;

    useEffect(() => {
        if (session && session.targetUsers) {
            setTargetUsers(session.targetUsers);
        }
    }, [session, setTargetUsers]);

    return (
        <Grid container spacing={1} flexGrow={0} alignItems="center" justifyContent="center" sx={{ marginBottom: 1 }}>
            <Grid item xs={12}>
                <Card variant="elevation">
                    <CardContent>
                        <Grid
                            container
                            spacing={1}
                            flexGrow={0}
                            alignItems="center"
                            sx={{
                                marginBottom: 1,
                            }}
                        >
                            <Grid item xs="auto">
                                <ContactsIcon color="success" />
                            </Grid>
                            <Grid item xs>
                                <Typography variant="h6" sx={{ marginBottom: 1 }}>
                                    Who to Send the Message To?
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} flexGrow={0} alignItems="center" justifyContent="center">
                            <Grid item xs={12}>
                                <RadioGroup
                                    value={targetUsers}
                                    onChange={e => {
                                        setTargetUsers(e.currentTarget.value as OnlyFansSubscriptionsUserType);
                                    }}
                                    sx={{ paddingBottom: 1 }}
                                >
                                    <FormControlLabel
                                        value={'onlineActive' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label={
                                            <div>
                                                <strong>Current Fans</strong> who are <strong>Online Right Now</strong>{' '}
                                            </div>
                                        }
                                    />
                                    <FormControlLabel
                                        value={'onlineFollowing' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label={
                                            <span>
                                                <strong>Those You Follow</strong> who are <strong>Online Right Now</strong>
                                            </span>
                                        }
                                    />
                                    <FormControlLabel
                                        value={'onlineAll' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label={
                                            <div>
                                                <strong>Current Fans & Those You Follow</strong> who are <strong>Online Right Now</strong>
                                            </div>
                                        }
                                    />
                                    <FormControlLabel
                                        value={'followingActive' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label="All Fans I Follow (Following→Active)"
                                    />
                                    <FormControlLabel
                                        value={'fansActive' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label="All Fans Following Me (Fans→Active)"
                                    />
                                    <FormControlLabel
                                        value={'fansAll' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label="All Fans and Following (Following→Active & Fans→Active)"
                                    />
                                    <FormControlLabel
                                        value={'followingExpired' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label="Expired Fans I Follow"
                                    />
                                    <FormControlLabel
                                        value={'recentSpenders' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label="Fans Who Recently Spent Money"
                                    />
                                    <FormControlLabel
                                        value={'recentFans' as OnlyFansSubscriptionsUserType}
                                        control={<Radio size="medium" />}
                                        label="Fans Who Recently Followed You"
                                    />
                                    <FormControlLabel value="lists" control={<Radio size="medium" />} label="Fans in Lists" />
                                </RadioGroup>
                            </Grid>

                            {unitCost !== 0 &&
                                targetUsers !== 'onlineActive' &&
                                targetUsers !== 'onlineFollowing' &&
                                targetUsers !== 'onlineAll' && (
                                    <Grid item xs={12}>
                                        <Alert variant="filled" severity="warning">
                                            Please be mindful of the cost when messaging a large group of users
                                        </Alert>
                                    </Grid>
                                )}
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default MessageUsersFormTargetUsers;
